export default __webpack_public_path__ + "static/media/arrow-down.fcf94ea1.svg";